import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "alertWarning",
  "use": "alertWarning-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"alertWarning\">\n<path d=\"M0.833496 9.99998C0.833496 4.93737 4.93755 0.833313 10.0002 0.833313C15.0628 0.833313 19.1668 4.93737 19.1668 9.99998C19.1668 15.0626 15.0628 19.1666 10.0002 19.1666C4.93755 19.1666 0.833496 15.0626 0.833496 9.99998ZM9.16683 13.3333V15H10.8335V13.3333H9.16683ZM9.16683 12.5H10.8335V5.83331H9.16683V12.5Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol